<template>
  <div>
    <div
      class="fields-item"
      :class="{'hideFields': isHide}"
    >
      <div
        class="fields-item-tit"
        @click="showHide"
      >
        <span>{{ sytleType }}</span>
        <i class="iconfont iconicon-test19" />
        <i class="iconfont iconicon-test18" />
      </div>
      <div
        class="fields-item-con"
      >
        <template v-if="type=== 'listStyle'">
          <list-style :item-data="itemData" />
        </template>
        <template v-else-if="type === 'inputAndSelect'">
          <input-select :item-data="itemData" />
        </template>
        <template v-else-if="type === 'font'">
          <font-style :item-data="itemData" />
        </template>
        <template v-else-if="type === 'button'">
          <button-style :item-data="itemData" />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ListStyle from './ListStyle'
import InputSelect from './InputSelect'
import FontStyle from './FontStyle'
import ButtonStyle from './ButtonStyle'
export default {
  components: {
    ListStyle,
    InputSelect,
    FontStyle,
    ButtonStyle
  },
  props: {
    itemData: {
      type: [Object, Number],
      default () {
        return {} || 0
      }
    }
  },
  data () {
    return {
      isHide: false
    }
  },
  computed: {
    ...mapState('universalForm/form', ['formDefaultDatas']),
    type () {
      const { itemData } = this
      const arrObj = Object.keys(itemData)
      if (arrObj.length) {
        return arrObj[0]
      } else {
        return ''
      }
    },
    sytleType () {
      const { type } = this
      let title = ''
      if (type === 'button') {
        title = this.$t('message["5"]')
      } else if (type === 'font') {
        title = this.$t('message["1271"]')
      } else if (type === 'inputAndSelect') {
        title = this.$t('message["1124"]')
      } else if (type === 'listStyle') {
        title = this.$t('message["691"]')
      }
      return title
    }
  },
  methods: {
    showHide () {
      this.isHide = !this.isHide
    }
  }
}
</script>
<style lang="scss" scoped>
  .fields-item::v-deep{
    border-top: 1px solid #ebebeb;
    .fields-item-tit {
      height: 40px;
      line-height: 40px;
      background: #f5f6f7;
      position: relative;
      padding-left: 12px;
      span {
        color: #333;
      }
      .iconfont {
        position: absolute;
        right: 12px;
        font-size: 16px;
        color: #d8d8d8;
        cursor: pointer;
      }
    }
    .fields-item-con {
      padding: 16px 0;
      .ant-btn-default {
        background: #fff;
        margin-bottom: 10px;
      }
      button[disabled] {
        background: #f7f7f7;
      }
      .input-select-item {
        height: 32px;
        line-height: 32px;
        float: left;
        padding:0 0 16px 4px;
        box-sizing: content-box;
        .input-select-item-label {
          display: inline-block;
          width: 80px;
          text-align: right;
        }
    .input-select-item-cell {
      display: inline-block;
      width: 180px;
    }
    .input-w {
      width: 108px;
    }
    .input-normal, .select-normal{
      width: 180px;
      .ant-input-number-input {
        width: 180px;
      }
    }
    .input-w-px {
      width: 64px;
      margin-left: 8px;
    }
    .input-color {
      width: 140px;
    }
  }
    }
    .iconicon-test19 {
      display: none;
    }
  }
  .hideFields {
    .iconicon-test19{
      display: inline-block;
    }
    .iconicon-test18, .fields-item-con {
      display: none;
    }
  }
</style>
